module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f07465_banner_800x600.1446b62b.png";